<app-loader *ngIf="isLoadingPage"></app-loader>

<div class="table-wrapper" [class.scrolling-left]="scrollingLeft" [class.scrolling-right]="scrollingRight" #tableRef
  [ngStyle]="{maxHeight: tableMaxHeight+'px'}">
  <table *ngIf="!isLoadingPage" matSort (matSortChange)="sortData($event)" mat-table
    [matSortActive]="sortRules?.active || ''" [matSortDirection]="sortRules?.direction || ''" [dataSource]="dataSource"
    class="custom-table">
    <caption [hidden]="true">Table</caption>
    <ng-container *ngFor="let col of tableCols; let i = index" [matColumnDef]="col.key">
      <!-- * HEADER  -->
      <ng-container *ngIf="col.showLabel">
        <th mat-header-cell [hidden]="columnViewerService.isHiddenColumn(col.key)" *matHeaderCellDef
          [id]="'th-' + idTable" [disabled]="!col.isSortable" [mat-sort-header]="col.key">
          {{ col.label | translate }}
        </th>
      </ng-container>
      <!-- *   -->


      <td [id]="'td-' + idTable" [hidden]="columnViewerService.isHiddenColumn(col.key)" mat-cell
        *matCellDef="let element; let i = index" [class.clickable-cell]="col.handler"
        [style.background-color]="i % 2 == 0 ? '#F0EDE8' : '#FFFFFF'"
        (click)="col?.handler ? col.handler(element) : null"
        [ngClass]="{'isCancelled' : trashbinIsDisabled(element) && col.key !== 'cancellationInfo','cancellationInfo': trashbinIsDisabled(element) && col.key === 'cancellationInfo'}">

        <!-- * -->
        <ng-container
          *ngIf="!col.hasIcon && !col.hasSelect && col.key !== 'isBookedForSales' && col.key !== 'actions' && col.key!=='message' && col.key!=='date' && col.key !== 'user'">
          <div class="flex-utility align-center">
            <ng-container *ngIf="col.hasAvatar">
              <app-product-avatar [media]="element.media || element.mediaUrl"> </app-product-avatar>
            </ng-container>
            <div
              [ngClass]="{'note-placeholder-text': !getProperty(element, col.key) && col.hasEditable, 'activity-text': getProperty(element, col.key) && col.key === 'activities', 'note-text': getProperty(element, col.key) && col.key === 'notes'}"
              [innerHTML]="getInformation(col,element)" [matTooltip]="getTooltip(col.key,element)"
              [matTooltipDisabled]="!col.hasTooltip" [matTooltipClass]="'table-tooltip'">
            </div>
            <div *ngIf="col.hasEditable">
              <img matRipple
                (click)="editNote({element: element, field: col.key === 'notes' ? 'note' : 'activity', inputText: col.key === 'notes' ? element.notes : col.key === 'activities' ? element.activities : ''})"
                class="action-icon" src="../../../assets/images/pencil_icon.svg" alt="'edit-pencil'">
            </div>
          </div>
        </ng-container>
        <!-- * -->

        <!-- * LOGISTIC STATUS -->
        <ng-container *ngIf="col.hasSelect">

          <ng-container *ngIf="col.hasEditable">
            <mat-spinner *ngIf="loadingRow === i" class="spinner"></mat-spinner>
            <span *ngIf="loadingRow !== i"
              [matTooltip]="!isDisabledLiveStatusButton(element, col.key) && col.hasEditable ? getTooltip(col.key,element) : element.tooltipMessageLogisticStatus || ''"
              [matTooltipDisabled]="!col.hasTooltip" [matTooltipClass]="'table-tooltip'">
              <button class="logistic-status" [class.dark]="col.key === 'logisticStatus'" mat-button
                [matMenuTriggerFor]="col.hasEditable ? menu : null"
                [disabled]="isDisabledLiveStatusButton(element, col.key)">
                <label>
                  {{element[col.key]}}
                </label>
              </button>
              <mat-menu #menu="matMenu" class="logistic-menu">
                <ng-container *ngIf="col.key === 'logisticStatus'">
                  <button class="logistic-menu-buttons" mat-menu-item
                    *ngFor="let status of getLogisticStatusMenu(element.logisticStatus)"
                    (click)="updateLogisticStatus(element, status, i)">
                    <span class="menu-status">
                      <label style="color: white !important;">{{status}} </label>
                    </span>
                  </button>
                </ng-container>
              </mat-menu>
            </span>
          </ng-container>

          <ng-container *ngIf="!col.hasEditable">
            <div *ngIf="col.key === 'isBackup' && element.isBackup" class="logistic-status-label isBackup">
              BACKUP
            </div>
            <div *ngIf="col.key !== 'isBackup'" class="logistic-status-label" [innerHTML]="getInformation(col,element)">
            </div>
          </ng-container>


        </ng-container>

        <!-- * IS AVAILABLE FOR ALLOCATION TICK & IS SELLABLE [ON / OFF] -->
        <ng-container *ngIf="col.hasIcon">
          <ng-container *ngIf="col.key === 'isHeroSelectionList' && !element.isHeroSelectionList">
            <img class="dw-icon" [src]="'../../../assets/images/dw_logo.svg'" alt="'dw'">
          </ng-container>
          <ng-container *ngIf="col.key === 'hasBookedForSale' && element.hasBookedForSale">
            <img class="bfs-icon" [src]="'../../../assets/images/placeholder_star.svg'" alt="has booked for sale">
          </ng-container>
          <ng-container *ngIf="col.key === 'isAvailableForAllocation'">
            <mat-slide-toggle [disabled]="isDisabledButton(col, element)" [checked]="element.isAvailableForAllocation"
              (toggleChange)="handleClick(col, element)"></mat-slide-toggle>
          </ng-container>
          <ng-container
            *ngIf="col.key !== 'isHeroSelectionList' && col.key !== 'hasBookedForSale' && col.key !== 'isAvailableForAllocation'">
            <button class="button-icon" [ngClass]="{'pointer': col.hasEditable}"
              [ngStyle]="{ 'margin': col.key === 'isSellable' ? '0 1em': '0 2em' }" (click)="handleClick(col, element)"
              [disabled]="isDisabledButton(col, element)">
              <img class="tick-icon" [matTooltip]="col.hasEditable ? getTooltip(col.key,element) : ''"
                [matTooltipDisabled]="!col.hasTooltip" matTooltipClass="table-tooltip"
                [src]="col.hasIcon ? (getInformationTick(element, col.key,col.hasIcon) ?  '../../../assets/images/tick_on.svg' : '../../../assets/images/tick_off.svg') : ''"
                alt="'tick'">
            </button>
          </ng-container>

        </ng-container>
        <!-- * -->

        <ng-container *ngIf="col.key === 'message'">
          <ng-container *ngFor="let text of (element.message)?.split('**'); let i = index;">
            <ng-container *ngIf="i % 2 !== 0; else normal_text">
              <b>{{text}}</b>
            </ng-container>
            <ng-template #normal_text>
              {{text}}
            </ng-template>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="col.key === 'user'">
          <span class="badge">{{element.user}}</span>
        </ng-container>

        <ng-container *ngIf="col.key === 'date'">
          <!-- <span>{{(element.date + "Z") | date: 'YYYY-MM-dd hh:mm a' }}</span> -->
          <span>{{element.date | date: 'YYYY-MM-dd hh:mm a' }}</span>
        </ng-container>

        <!-- * ACTION EDIT -->
        <ng-container *ngIf="col.key === 'actions'">
          <button matRipple class="button-icon"
            (click)="editAction({element: element, field: 'engravement', inputText: element.engravings},element)">
            <img class="action-icon-pencil" src="../../../assets/images/pencil_icon.svg" alt="'pencil'">
          </button>
        </ng-container>
        <ng-container *ngIf="col.key === 'financeActions'">
          <div class="d-flex">
            <button matRipple class="button-icon" (click)="financeIconAction(element, true)">
              <img class="action-icon-pencil" src="../../../assets/images/finance_export.svg" alt="'pencil'">
            </button>
            <button matRipple class="button-icon" (click)="financeIconAction(element)">
              <img class="action-icon-pencil" src="../../../assets/images/eye.svg" alt="'pencil'">
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="col.key === 'view'">
          <button matRipple class="button-icon" (click)="iconAction.emit(element)">
            <img class="action-icon-pencil" src="../../../assets/images/eye.svg" alt="'pencil'">
          </button>
        </ng-container>
        <ng-container *ngIf="col.key === 'isDone'">
          <button class="button-icon" (click)="iconAction.emit({element,index: i})">
            <img class="tick-icon" [matTooltip]="getTooltip(col.key, element)" [matTooltipDisabled]=" !col.hasTooltip"
              matTooltipClass="table-tooltip"
              [src]="element.isDone?  '../../../assets/images/tick_on.svg' : '../../../assets/images/tick_off.svg'"
              alt="'tick'">
          </button>

        </ng-container>
        <!-- * -->
        <!-- * TRASHBIN DELETE -->
        <ng-container *ngIf="col.key === 'trashbin'">
          <span [matTooltip]="trashbinIsDisabled(element) ? getTooltip(col.key,element) : ''"
            [matTooltipDisabled]="!trashbinIsDisabled(element)" [matTooltipClass]="'table-tooltip'">
            <button class="delete-icon" (click)="deleteBookedForSales(element)"
              [disabled]="trashbinIsDisabled(element)">
              <img class="action-icon-delete" src="../../../assets/images/delete_icon.svg" alt="'delete'">
            </button>
          </span>
        </ng-container>
        <!-- * -->

        <!-- * BOOK FOR SALES DETAILS -->
        <ng-container *ngIf="col.key === 'isBookedForSales'">
          <span [matTooltip]="!element.isBookedForSales ? getTooltip(col.key,element) : ''"
            [matTooltipDisabled]="!col.hasTooltip" [matTooltipClass]="'table-tooltip'">
            <button class="button-icon-book-for-sales" [disabled]="!element.isBookedForSales"
              (click)="element.isBookedForSales ? openDashboardDetailDialog(element) : null">
              <img class="action-icon-book-for-sales" src="../../../assets/images/book_for_sale_icon.svg"
                alt="'book_for_sale_icon'">
            </button>
          </span>
        </ng-container>
        <!-- * -->
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="keys; sticky:true"></tr>
    <tr mat-row *matRowDef="let row; columns: keys"></tr>

  </table>
  <mat-paginator *ngIf="responseProduct" #paginator sticky [id]="'paginator-' + idTable" aria-label="Select page"
    [class.hide-paginator]="isLoadingPage" [hidden]="isLoadingPage" (page)="handlePageEvent($event)"
    [pageIndex]="pageIndex" [showFirstLastButtons]="true" [pageSizeOptions]="[limit]"
    [length]="responseProduct.count || 0"></mat-paginator>
</div>
